import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FlameIcon } from '../icons/SalesIcons';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/7s91y8mtepWnhJYB46aVBT/Donde_la_elegancia_se_convierte_en_aroma.Un_ramo_unico_de_velas_aromaticas_que_ilumina,_decora_.webp',
  alt: 'Ramo de velas florales artesanales — elegancia hecha a mano',
  caption: 'Ramos de velas florales',
  sub: 'Donde la elegancia se convierte en aroma'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7zehDibjU5dDTVqbSCfcR9/Un_antojo_que_no_se_come,_pero_que_ilumina_🍓🕯️.webp',
  alt: 'Vela repostería de fresa con chantilly — parece un postre real',
  caption: 'Velas repostería',
  sub: 'Un antojo que no se come, pero que ilumina'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xhpjCoTZYqUDr2hMAahThk/La_ternura_de_este_mes_acompanada_como_siempre_de_velitas🩷🧸Y_lo_mejor_Es_que_puedes_aprender_c.jpg',
  alt: 'Velas decorativas de osito con corazones',
  caption: 'Velas decorativas de molde',
  sub: 'Ternura y creatividad en cada detalle'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cLpwVc1k3b4KF4aRFiqZUE/Asi_iniciamos_este_2026_🩷✨Enero_llego_lleno_de_creacion,_aprendizaje_y_muchisimas_velas_hechas_(3).jpg',
  alt: 'Vela repostería red velvet con fresa y chocolate',
  caption: 'Velas red velvet',
  sub: 'Creaciones que parecen salidas de una pastelería'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oMDVaxZbmK64XeGrDTs1uB/Screenshot_2026-01-11_183938.png',
  alt: 'Stefany mostrando sus creaciones de velas artesanales',
  caption: 'Creaciones de nuestras alumnas',
  sub: 'Esto es lo que logras con el sistema correcto'
}];
export function GallerySection() {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % galleryImages.length);
  }, []);
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(next, 3500);
    return () => clearInterval(timer);
  }, [isPaused, next]);
  return <section className="bg-[#2D2926] py-16 md:py-24 overflow-hidden" data-id="element-181">
      <div className="max-w-6xl mx-auto px-4" data-id="element-182">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-183">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-184">
            <FlameIcon size={32} className="text-[#C4A882]" data-id="element-185" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-white mb-3" data-id="element-186">
            Esto Es Lo Que Vas a Crear
          </h2>
          <p className="text-lg text-[#D4A0A0]" data-id="element-187">
            Creaciones reales de nuestras alumnas y de Stefany
          </p>
        </motion.div>

        {/* Gallery */}
        <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-188">
          {/* Main Image */}
          <div className="relative aspect-[3/4] md:aspect-[4/3] rounded-2xl overflow-hidden bg-[#1a1715] mb-6" data-id="element-189">
            <AnimatePresence mode="wait" data-id="element-190">
              <motion.img key={current} src={galleryImages[current].src} alt={galleryImages[current].alt} initial={{
              opacity: 0,
              scale: 1.05
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.98
            }} transition={{
              duration: 0.6
            }} className="absolute inset-0 w-full h-full object-contain" data-id="element-191" />
            </AnimatePresence>

            {/* Overlay gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D2926] via-transparent to-transparent" data-id="element-192" />

            {/* Caption */}
            <AnimatePresence mode="wait" data-id="element-193">
              <motion.div key={current} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.4,
              delay: 0.2
            }} className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-194">
                <p className="font-heading text-xl md:text-2xl text-white mb-1" data-id="element-195">
                  {galleryImages[current].caption}
                </p>
                <p className="text-[#C4A882] text-sm md:text-base" data-id="element-196">
                  {galleryImages[current].sub}
                </p>
              </motion.div>
            </AnimatePresence>

            {/* Progress bar */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-white/10" data-id="element-197">
              <motion.div key={current} className="h-full bg-gradient-to-r from-[#C4A882] to-[#9B2335]" initial={{
              width: '0%'
            }} animate={{
              width: '100%'
            }} transition={{
              duration: 3.5,
              ease: 'linear'
            }} data-id="element-198" />
            </div>
          </div>

          {/* Thumbnails */}
          <div className="flex gap-3 justify-center" data-id="element-199">
            {galleryImages.map((img, index) => <button key={index} onClick={() => setCurrent(index)} className={`relative w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden transition-all duration-300 flex-shrink-0 ${index === current ? 'ring-2 ring-[#C4A882] scale-105 shadow-lg shadow-[#C4A882]/30' : 'opacity-50 hover:opacity-80'}`} aria-label={`Ver imagen ${index + 1}: ${img.caption}`} data-id="element-200">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-201" />
                {index === current && <motion.div layoutId="thumb-highlight" className="absolute inset-0 border-2 border-[#C4A882] rounded-lg" transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-202" />}
              </button>)}
          </div>
        </div>
      </div>
    </section>;
}